import { render, staticRenderFns } from "./PropertiesSearchMainHouseMateGroup.vue?vue&type=template&id=68fe1f70"
import script from "./PropertiesSearchMainHouseMateGroup.vue?vue&type=script&lang=js"
export * from "./PropertiesSearchMainHouseMateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports